const SearchClear = () => {
    const searchInputs = document.querySelectorAll('.search-form__field');

    searchInputs.forEach(input => {
        const clearButton = document.createElement('button');
        clearButton.className = 'search-form__clear-button';
        clearButton.textContent = '';

        input.parentNode.appendChild(clearButton);

        input.addEventListener('input', function () {
            clearButton.style.display = this.value ? 'block' : 'none';
        });

        clearButton.addEventListener('click', function () {
            event.preventDefault();
            input.value = '';
            clearButton.style.display = 'none';
        });
    });
};

export default SearchClear;
